import { SelectedFileError } from '@modules/integrationsV2/types';
import CancelIcon from '@mui/icons-material/Cancel';
import { alpha, Box, Divider, Stack, Typography } from '@mui/material';
import { FileUploadName } from './FileUploadName';

interface FileUploadErrorModalContentProps {
  fileName: string;
  selectedFileError: SelectedFileError;
}

export const FileUploadErrorModalContent = ({
  fileName,
  selectedFileError,
}: FileUploadErrorModalContentProps) => {
  return (
    <Box
      p={1.25}
      mb={2}
      border="1px solid"
      borderColor="divider"
      borderRadius={1}
      sx={{ background: (theme) => alpha(theme.palette.text.primary, 0.02) }}
    >
      <Stack spacing={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" spacing={1.25}>
            <CancelIcon color="error" />
            <Typography color="error">
              {selectedFileError.errorType === 'file_size_exceeded'
                ? 'File size too large'
                : 'Could not upload the file'}
            </Typography>
          </Stack>
          <FileUploadName fileName={fileName} />
        </Stack>
        <Divider />
        <Box p={1}>
          <Typography variant="body2" color="text.secondary">
            {selectedFileError.message}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
